export const config = {
  development: {
    // API Gateway endpoint URL
    apiUrl: process.env.REACT_APP_API_URL || 'https://bnab07nqji.execute-api.us-east-1.amazonaws.com/dev',

    // Environment mode (dev/prod)
    mode: 'dev',

    // Maximum file size in bytes (5MB)
    maxFileSize: 5 * 1024 * 1024,

    // Allowed file types for upload
    allowedTypes: ['.csv'],

    // Logging level for development
    logLevel: 'debug',

    // Request timeout in milliseconds
    requestTimeout: 30000,

    // Maximum retry attempts for failed requests
    maxRetries: 3
  },
  production: {
    // API Gateway endpoint URL (override with REACT_APP_API_URL env var)
    apiUrl: process.env.REACT_APP_API_URL,

    // Environment mode (dev/prod)
    mode: 'prod',

    // Maximum file size in bytes (5MB)
    maxFileSize: 5 * 1024 * 1024,

    // Allowed file types for upload
    allowedTypes: ['.csv'],

    // Logging level for production (errors only)
    logLevel: 'error',

    // Request timeout in milliseconds
    requestTimeout: 30000,

    // Maximum retry attempts for failed requests
    maxRetries: 3
  }
};

/**
 * Get configuration for current environment
 * @returns {Object} Configuration object for current environment
 */
export const getConfig = () => {
  const mode = process.env.REACT_APP_MODE || process.env.NODE_ENV || 'dev';
  const normalizedMode = (mode === 'production' || mode === 'prod') ? 'production' : 'development';
  return config[normalizedMode];
};

/**
 * Get specific config value
 * @param {string} key - Configuration key
 * @returns {*} Configuration value
 */
export const getConfigValue = (key) => {
  const currentConfig = getConfig();
  return currentConfig[key];
};

export default {
  config,
  getConfig,
  getConfigValue
};

// Login API URL
export const LOGIN_API = "https://auth.api.celcomdigi.tech/login/profile"
